import { AxiosResponse } from "axios";
import { Response } from "../../types/api";
import protectedInstance from "../instances/protected";
import publicInstance from "../instances/public";
import download from "downloadjs";

// Agreement status dictionary
export const AGREEMENT_STATUS = {
  CREATION: "CREATION",
  SIGN_CUSTOMER: "SIGN_CUSTOMER",
  SIGN_SUPPLIER: "SIGN_SUPPLIER",
  REJECT: "REJECT"
};

// Agreement interface based on the provided JSON structure
export interface Agreement {
  id: number;
  fileId: string;
  warrant: string;
  status: string;
  supplierId: number;
  supplierName: string;
  customerId: number;
  customerName: string;
  auctionLotId: number;
  dueDate?: Date | string | null;
  createdBy: number;
  updatedBy: number;
  createdAt: number;
  updatedAt: number;
}

interface GetAgreementsResponse {
  success: boolean;
  code: string;
  message: string;
  data: Agreement[];
}

interface CreateAgreementResponse {
  success: boolean;
  code: string;
  message: string;
  data: Agreement;
}

async function getAgreements(companyId: number, auctionId: number) {
  return protectedInstance
    .get(`/company/${companyId}/auction/${auctionId}/agreements`)
    .then((res: AxiosResponse<Response<Agreement[]>>) => res.data);
}

async function createAgreement(companyId: number, auctionId: number, warrant: string, dueDate?: Date | null) {
  return protectedInstance
    .post(`/company/${companyId}/auction/${auctionId}/agreement/create`, { warrant, dueDate })
    .then((res: AxiosResponse<Response<any>>) => res.data);
}

async function signAgreement(agreementId: number, companyId: number, formData: FormData) {
  return protectedInstance
    .post(`/company/${companyId}/agreement/${agreementId}/sign`, formData)
    .then((res: AxiosResponse<Response<any>>) => res.data);
}



async function downloadFile(companyId: number, agreementId: number) {
  return protectedInstance({
    url: `company/${companyId}/agreement/${agreementId}/download`,
    method: 'get',
    responseType: 'blob',
  })
      .then((res: AxiosResponse<any>) => {
        const content = res.headers["content-type"];
        const fileName = res.headers["content-disposition"].split(";")[1].split("=")[1];
        download(res.data, fileName, content)
      })
}

async function getPassport(companyId: number, agreementId: number) {
  return protectedInstance
      .get(`/company/${companyId}/agreement/${agreementId}/passport`)
      .then((res: AxiosResponse<Response<{ passport: string }>>) => res.data)
}

async function signPassport(companyId: number, agreementId: number, formData: FormData) {
  return protectedInstance
      .post(`/company/${companyId}/agreement/${agreementId}/sign`, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
      .then((
          res: AxiosResponse<Response<{ errorMessage: string | null }> &
              { errorMessage: string | null }>
      ) => res.data)
}

export const agreementService = {
  getAgreements,
  createAgreement,
  downloadFile,
  getPassport,
  signPassport
};
